import styled from 'styled-components'

//----- Styling -----//

export const ViewTitle = styled.div`
	margin-bottom: 1em;
	font-weight: ${(p) => p.theme.font.sans.weight.bold};
`
